import _ from "lodash";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IonLoading, IonToast, IonIcon, IonButton } from "@ionic/react";
import { checkmarkCircleOutline, closeCircleOutline } from "ionicons/icons";

import { Alert } from "../../components";
import {
  clearAppProcessing,
  clearAppSuccess,
  clearAppError,
  clearAll,
} from "../../modules";
import strings from "../../../../res/strings";

import styled from "styled-components";
const Container = styled.div``;

const Banner = styled.div`
  padding-top: 25vh;
  text-align: center;
`;
const BannerIcon = styled(IonIcon)`
  font-size: 64px;
  color: #ffffff;
`;
const BannerTitle = styled.div`
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  font-size: 2em;
  color: #ffffff;

  letter-spacing: 0.1em;

  text-align: center;
`;
const BannerMessage = styled.div`
  font-family: Secular One;
  color: #ffffff;
  padding: 0px 8px 0px 8px;
  margin-bottom: 8px;
  font-size: 1.5em;
`;
const BannerButtonGroup = styled.div`
  margin-top: 8px;
`;
const BannerButton = styled(IonButton)`
  width: 100%;
  background: #039095;
  border-radius: 250.251px;
  font-size: 1.5em;
  font-family: Secular One;
  color: #ffffff;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  padding: 16px;
  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }
`;

const BannerRedirectGroup = styled.div`
  margin: 16px;
  padding: 8px;
`;
const BannerRedirectContainer = styled.div``;
const BannerRedirect = styled.a`
  color: #929292;
  font-family: Secular One;
  cursor: pointer;

  :hover {
    color: #7a7a7a;
  }
`;

const AppStateDisplay = (props) => {
  //////////////////////////////////////////////
  //////////      SUCCESS ALERTS      //////////
  //////////////////////////////////////////////
  const successAlert =
    _.get(props.success, "notificationType") === "alert" ? (
      <Alert color="success">{props.success.message}</Alert>
    ) : null;

  // lib.authentication special success cases
  const logoutSuccessAlert =
    _.get(props.parsedQuery, "logoutAccount") && !props.error ? (
      <Alert color="success">
        {strings.lib_authentication_state_success_logout}
      </Alert>
    ) : null;

  const registerSuccessAlert =
    _.get(props.parsedQuery, "registerSuccess") && !props.error ? (
      <Alert color="success">
        {strings.lib_authentication_state_success_register}
      </Alert>
    ) : null;

  //////////////////////////////////////////////
  //////////       ERROR ALERTS       //////////
  //////////////////////////////////////////////
  const errorAlert =
    _.get(props.error, "notificationType") === "alert" ? (
      <Alert color="danger">{props.error.message}</Alert>
    ) : null;

  //////////////////////////////////////////////
  //////////      SUCCESS BANNERS     //////////
  //////////////////////////////////////////////
  const successBanner =
    _.get(props.success, "notificationType") === "banner" ? (
      <Banner>
        <BannerIcon
          style={{ color: "#0d9e0d" }}
          icon={checkmarkCircleOutline}
        />
        <BannerTitle>{_.get(props.success, "title")}</BannerTitle>
        <BannerMessage>{_.get(props.success, "message")}</BannerMessage>
        {_.get(props.success, "buttons") && (
          <BannerButtonGroup>
            {_.get(props.success, "buttons", []).map((b, index) => {
              return <BannerButton key={index}>{b.label}</BannerButton>;
            })}
          </BannerButtonGroup>
        )}
        {_.get(props.success, "redirects") && (
          <BannerRedirectGroup>
            {_.get(props.success, "redirects", []).map((r, index) => {
              return (
                <BannerRedirectContainer key={index}>
                  <BannerRedirect onClick={r.onClick}>{r.label}</BannerRedirect>
                </BannerRedirectContainer>
              );
            })}
          </BannerRedirectGroup>
        )}
      </Banner>
    ) : null;

  //////////////////////////////////////////////
  //////////       ERROR BANNERS      //////////
  //////////////////////////////////////////////
  const errorBanner =
    _.get(props.error, "notificationType") === "banner" ? (
      <Banner>
        <BannerIcon color="danger" icon={closeCircleOutline} />
        <BannerTitle>{_.get(props.error, "title")}</BannerTitle>
        <BannerMessage>{_.get(props.error, "message")}</BannerMessage>
        {_.get(props.error, "buttons") && (
          <BannerButtonGroup>
            {_.get(props.error, "buttons", []).map((b, index) => {
              return <BannerButton key={index}>{b.label}</BannerButton>;
            })}
          </BannerButtonGroup>
        )}
        {_.get(props.error, "redirects") && (
          <BannerRedirectGroup>
            {_.get(props.error, "redirects", []).map((r, index) => {
              return (
                <BannerRedirectContainer key={index}>
                  <BannerRedirect onClick={r.onClick}>{r.label}</BannerRedirect>
                </BannerRedirectContainer>
              );
            })}
          </BannerRedirectGroup>
        )}
      </Banner>
    ) : null;

  // Due to a bug with IonLoading,
  // the processing message is hardcoded.
  return (
    <Container>
      {successAlert}
      {logoutSuccessAlert}
      {registerSuccessAlert}
      {errorAlert}
      {successBanner}
      {errorBanner}
      {props.children}
      {props.processing !== null && (
        <IonLoading
          isOpen={props.processing !== null}
          message={strings.lib_common_state_loading}
          translucent={true}
        />
      )}
      <IonToast
        isOpen={_.get(props.success, "notificationType") === "toast"}
        message={_.get(props.success, "message", null)}
        duration={1000 * 3}
        onDidDismiss={() => props.clearAppSuccess()}
      />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  processing: state.lib_application.processing,
  success: state.lib_application.success,
  error: state.lib_application.error,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearAppProcessing,
      clearAppSuccess,
      clearAppError,
      clearAll,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AppStateDisplay);
